import { createLogger } from 'shared/services/logger';
import { store } from 'shared/stores/core/decorators';
import { getPlugin } from './plugin-access';

const logger = createLogger('@store(USCOPE)');

@store('USCOPE')
export class UScopeState {
  // global uScope reference. Note that this is *not* attached to "state" to prevent Vue from converting all public
  // members to Vue Observables.
  uScope = null;

  getters = {
    uScope: () => this.uScope,
    plugins: ({uScopeApi}) => (pluginName) => getPlugin(uScopeApi, this.uScope, pluginName)
  };

  constructor ({uScopeApi, dispatch}) {
    const self = this;

    uScopeApi.plugins.register({
      name: 'us:stores:uScope',

      extends: 'uScope',

      constructor (uScope) {
        self.uScope = uScope;
        dispatch('USCOPE_BIND_EVENTS', uScope);
      }
    });
  }

  USCOPE_NOTIFY (store, {type = 'info', message}) {
    const notifier = this.uScope.notifications[type];
    if (notifier) {
      notifier(message);
    } else {
      logger.warn(`USCOPE_NOTIFY: type "${type}" doesn't exist. Cannot send message "${message}"`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/uScope/UScopeState.js